import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.setTheme(localStorage.getItem("theme") || "light")
  }

  toggle() {
    this.setTheme(document.body.dataset.theme === "light" ? "dark" : "light")
  }

  setTheme(theme) {
    document.body.dataset.theme = theme
    localStorage.setItem("theme", theme)

    this.element.querySelector(".bi-sun-fill").style.display = theme === "dark" ? "inline-block" : "none"
    this.element.querySelector(".bi-moon-stars-fill").style.display = theme === "dark" ? "none" : "inline-block"
  }
}
